import { Emitter, Event } from "../../../../../features/event-emitter"
import { Address } from "../../../../../features/address"
import { useCustomerService } from "../../../services/customerService"

export const useActions = () => {
    const { updateCustomerProps } = useCustomerService()

    const updateCustomerAddress = async (
        customerId: string,
        mainAddress: Address
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        const updatedCustomer = await updateCustomerProps(customerId, { mainAddress })
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false)

        return updatedCustomer
    }

    return {
        updateCustomerAddress
    }
}
